import React from 'react';
import ContactUsForm from '../../..';

const ContactUsMemberForm = props => <ContactUsForm {...props} />;

export default ContactUsMemberForm;
